import { Box, styled, useMediaQuery, useTheme } from '@mui/material';
import React, { useState } from 'react';
import { UsePagination } from '@/components/blocks/UsePagination';

const Grid = styled(Box)(({ theme }) => ({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	alignContent: 'center',
	alignItems: 'center',
	justifyContent: 'space-between',
	gap: 2,
	marginBottom: theme.spacing(8),
}));

export const DpBlogGrid = ({ children }: { children: React.ReactNode }) => {
	const [page, setPage] = useState(0);

	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	const itemsPerPage = isMobile ? 6 : 9;

	const handleChangePage = (_: unknown, newPage: number) => {
		setPage(newPage - 1);
	};

	const childrenArray = React.Children.toArray(children).filter((item) => typeof item === 'object');

	const startIndex = page * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const displayedChildren = childrenArray.slice(startIndex, endIndex);
	const count = Math.ceil(childrenArray.length / itemsPerPage);

	return (
		<Box>
			<Grid>{displayedChildren}</Grid>
			<UsePagination count={count} onChange={handleChangePage} />
		</Box>
	);
};
